
import { useAuthState } from './useAuthState';
import { useAuthActions } from './useAuthActions';
import { useAuthListeners } from './useAuthListeners';

export const useAuth = () => {
  const {
    user,
    setUser,
    session,
    setSession,
    isLoading,
    setIsLoading,
    error,
    setError,
    authEvent,
    setAuthEvent,
    isAuthenticated
  } = useAuthState();

  const { login, register, logout } = useAuthActions(setIsLoading, setError);
  const { initializeAuth, setupAuthListener } = useAuthListeners(setUser, setSession, setIsLoading, setAuthEvent);

  return {
    // State
    user,
    session,
    isLoading,
    error,
    isAuthenticated,
    authEvent,
    
    // Actions
    login,
    register,
    logout,
    
    // Initialization
    initializeAuth,
    setupAuthListener
  };
};
